import React, { useEffect, useState, constructor } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ITeacher, listTeachers, createTeacher, updateTeacher, deleteTeacher, pageTeachers } from '../../service/api/teacher';
import { IStore, listStores } from '../../service/api/store';
import { IStudentDetail, getStudent } from '../../service/api/student';
import moment from 'moment';
import { ICardDefinition, listCardDefinitions } from '../../service/api/cardDefinition';
import { ICard, createCard } from '../../service/api/card';
import CardList from '../card/CardList';
import { Link } from 'react-router-dom';
import { FormInstance } from 'antd/lib/form/Form';
const { confirm } = Modal;
const { Option } = Select;
// import queryString from 'query-string';

// const values = queryString.parse(window.location.search)

function getUrlParam(name:string, str:string) {
  const paramUrl = str.split('?');
  const params = paramUrl[1].split('&');
  for (var i=0;i<params.length;i++){
    const value = params[i].split('=');
    if(value[0]==name){
      return value[1];
    }
   }
  return null;
}

const StudentCardView = (props: any) => {
  const [studentDetail, setStudentDetail] = useState<IStudentDetail>();
  console.log('csn:'+getUrlParam('studentId',window.location.href));

  useEffect(() => {
    if (!studentDetail) {
      loadData();
    }
  },[studentDetail]);

  const loadData = () => {
    getStudent(getUrlParam('studentId',window.location.href)).then((info: any) => {
      setStudentDetail(info?.data);
    });
  }


  return (
    // 【知识点】在return中动态加载标签
    <div className="gutter-example">
      <BreadcrumbCustom breads={[<Link to={'/app/student'}>学员管理</Link>,'已购课包']} />
      <Card  bordered={true} style={{ width: '100%', height: '80px', borderColor: '#F0EFEF' }}>
      {studentDetail?.courseInfo?.map((cou) => 
        <span style={{ fontSize: '20px' }}>【{cou.name}】剩余{cou.count}课时，有效至{moment(cou.effectiveDate).format('YYYY-MM-DD')}</span>)}
        </Card>
      <CardList studentId={getUrlParam('studentId',window.location.href)}/>
    </div>
  );
};

export default StudentCardView;
